// extracted by css-extract-rspack-plugin
export default {"HeadlineImage":"HeadlineImage-errHsH","headlineImage":"HeadlineImage-errHsH","Card":"Card-OMyZKY","card":"Card-OMyZKY"};